import { render, staticRenderFns } from "./TerminationReasons.vue?vue&type=template&id=e6c8d244"
import script from "./TerminationReasons.vue?vue&type=script&lang=js"
export * from "./TerminationReasons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports